'use strict';

let counter = 0;
function getUUID() {
    return `ss-id-${++counter}`;
}

module.exports = getUUID;
